module.exports = __webpack_public_path__ + "img/Slide.0.10ca9592.jpg";